import {DateTime} from "luxon";

export default {
    methods: {
        getDateTimeFormatLocalizeFromISO(_date) {
            return  {
                "date" : DateTime.fromISO(_date).toFormat('DDD'),
                "time" : DateTime.fromISO(_date).toFormat('TT') ,
                "time1" : DateTime.fromISO(_date).toFormat('T') ,
            }
        },
    }
}